import moment from 'moment';
import { mailBoxOfAllRes, mailBoxOfCustomerUnFollow, mailBoxOfUnFollow, mailBoxOfDefault, mailBoxOfDefer, mailBoxOfRdFlag, } from './mail_action_store_model';
import { api } from '@/api/api';
import { MailAbstractHandler } from './mail_abs_handler';
import { apis } from '@/config';
import corpMailUtils from './corp_mail_utils';
import { getIn18Text } from '@/api/utils';
import { FolderErrResult } from '@/api/errMap';
export class MailFolderHandler extends MailAbstractHandler {
    constructor(actions, modelHandler, contactHandler, mailDbHandler, subActions) {
        super(actions, modelHandler, contactHandler, mailDbHandler, subActions);
        this.fileApi = api.getFileApi();
        this.errReportApi = api.requireLogicalApi(apis.errorReportImpl);
        this.loggerApi = api.requireLogicalApi(apis.loggerApiImpl);
        this.contactApi = api.requireLogicalApi(apis.contactApiImpl);
    }
    unpackFolderData(res) {
        console.log('[mail] return from network:', res);
        const isCorpMailMode = this.systemApi.getIsCorpMailMode();
        if (isCorpMailMode) {
            corpMailUtils.corpMailTransformResponse(res);
        }
        const data = res.data;
        if (data && data.code !== MailAbstractHandler.sOk) {
            res.config.requestFailed = true;
        }
        return data;
    }
    async doListMailBox(noCache, updateStat, entries, _account) {
        var _a;
        const p1 = () => this.doListFolder(noCache, entries, _account);
        const p2 = updateStat ? () => Promise.resolve(null) : () => this.doStatMessages(noCache, updateStat, undefined, _account);
        const p4 = !(process.env.BUILD_ISEDM || ((_a = this.systemApi.doGetProductInfo()) === null || _a === void 0 ? void 0 : _a.navigateVersion))
            ? () => Promise.resolve(null)
            : () => this.doStatMessagesUnFollow(noCache, _account);
        return Promise.all([p1(), p2(), p4()])
            .then(([mailBoxModels, deferEntry, p4Res]) => {
            const customerUnFollowEntry = p4Res && p4Res[0];
            const unFollowEntry = p4Res && p4Res[1];
            const newEntries = entries;
            mailBoxModels.forEach(v => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                if (deferEntry && v.mailBoxId === mailBoxOfDefer.id) {
                    const oldName = (_a = v === null || v === void 0 ? void 0 : v.entry) === null || _a === void 0 ? void 0 : _a.mailBoxName;
                    newEntries && newEntries.push(deferEntry.entry);
                    if (((_b = v.entry) === null || _b === void 0 ? void 0 : _b._deep) != null) {
                        deferEntry.entry._deep = (_c = v.entry) === null || _c === void 0 ? void 0 : _c._deep;
                    }
                    v.entry = deferEntry.entry;
                    if (oldName) {
                        v.entry.mailBoxName = oldName;
                    }
                }
                if (customerUnFollowEntry && v.mailBoxId === mailBoxOfCustomerUnFollow.id) {
                    const oldName = (_d = v === null || v === void 0 ? void 0 : v.entry) === null || _d === void 0 ? void 0 : _d.mailBoxName;
                    newEntries && (newEntries === null || newEntries === void 0 ? void 0 : newEntries.push(customerUnFollowEntry.entry));
                    if (((_e = v.entry) === null || _e === void 0 ? void 0 : _e._deep) != null) {
                        customerUnFollowEntry.entry._deep = (_f = v.entry) === null || _f === void 0 ? void 0 : _f._deep;
                    }
                    v.entry = customerUnFollowEntry.entry;
                    if (oldName) {
                        v.entry.mailBoxName = oldName;
                    }
                }
                if (unFollowEntry && v.mailBoxId === mailBoxOfUnFollow.id) {
                    const oldName = (_g = v === null || v === void 0 ? void 0 : v.entry) === null || _g === void 0 ? void 0 : _g.mailBoxName;
                    newEntries && (newEntries === null || newEntries === void 0 ? void 0 : newEntries.push(unFollowEntry.entry));
                    if (((_h = v.entry) === null || _h === void 0 ? void 0 : _h._deep) != null) {
                        unFollowEntry.entry._deep = (_j = v.entry) === null || _j === void 0 ? void 0 : _j._deep;
                    }
                    v.entry = unFollowEntry.entry;
                    if (oldName) {
                        v.entry.mailBoxName = oldName;
                    }
                }
            });
            if (newEntries) {
                this.saveMailContentToAction(mailBoxModels, newEntries, _account);
            }
            console.log('[doListMailBox]', _account, mailBoxModels, deferEntry);
            return mailBoxModels;
        })
            .catch(e => Promise.reject(this.commonCatch(e)));
    }
    async doListMailBoxByAccountIds(noCache, entries, _accountIds) {
        try {
            return this.doListFolderByAccountIds(_accountIds, noCache, entries);
        }
        catch (e) {
            return Promise.reject(this.commonCatch(e));
        }
    }
    async getStarMailUnreadFromServer(params, _account) {
        const urlKey = 'contactStats';
        const url = this.buildUrl(urlKey, undefined, undefined, _account);
        const apiRet = await this.impl.post(url, params, this.getConfigForHttp(urlKey, {
            url,
            data: params,
            method: 'post',
            cachePolicy: 'refresh',
            _account,
        }));
        const res = this.unpackFolderData(apiRet);
        if (res.code !== MailAbstractHandler.sOk || !res.var) {
            throw new Error(String(res.code) || 'unknown_err');
        }
        return res.var;
    }
    async updateStarUnread(starList, addressContactMap, _account) {
        const reqParams = {
            addresses: Object.keys(addressContactMap),
            addressType: 2,
            returnAll: false,
        };
        const { stats } = await this.getStarMailUnreadFromServer(reqParams, _account);
        const contactUnreadMap = {};
        stats.forEach(({ address, newMsgCnt }) => {
            const addressContact = addressContactMap[address];
            if (addressContact) {
                addressContact.contactsBelong.forEach(contact => {
                    if (!contactUnreadMap[contact]) {
                        contactUnreadMap[contact] = 0;
                    }
                    contactUnreadMap[contact] += newMsgCnt;
                });
            }
        });
        const idMap = {};
        starList.forEach(({ starInfo, entry }) => {
            const contactId = starInfo === null || starInfo === void 0 ? void 0 : starInfo.id;
            if (contactId && contactUnreadMap[contactId] !== undefined) {
                const unread = contactUnreadMap[contactId];
                entry.mailBoxUnread = unread;
                entry.mailBoxCurrentUnread = unread;
                entry.threadMailBoxUnread = unread;
                entry.threadMailBoxCurrentUnread = unread;
                idMap[contactId] = unread;
            }
        });
        await this.contactApi.doUpdateMarkUnreadMailCount(idMap, _account);
        return starList;
    }
    async doListFolder(noCache, entries, _account) {
        var _a;
        const urlKey = 'listFolder';
        const dt = {
            order: 'custom_virtual',
        };
        if (noCache) {
            await this.mailConfApi.loadMailConf(_account);
        }
        try {
            let starListUnreadPromise = Promise.resolve([]);
            if (!(process.env.BUILD_ISEDM || ((_a = this.systemApi.doGetProductInfo()) === null || _a === void 0 ? void 0 : _a.navigateVersion))) {
                starListUnreadPromise = this.doStarContactUnread(_account);
            }
            const [entryDt, startListWithNewUnread] = await Promise.all([this.listMailEntry(dt, urlKey, noCache, _account), starListUnreadPromise]);
            await this.buildFolderConf(_account);
            const mailBoxModels = await this.modelHandler.handleCommonFolderRet(entryDt, startListWithNewUnread, _account);
            this.saveMailContentToAction(mailBoxModels, entryDt, _account);
            if (entries) {
                entries.push(...entryDt);
            }
            return mailBoxModels;
        }
        catch (e) {
            return Promise.reject(this.commonCatch(e));
        }
    }
    async doListFolderByAccountIds(_accountIds, noCache, entries) {
        const urlKey = 'listFolder';
        const dt = {
            order: 'custom_virtual',
            subEmails: _accountIds.filter(it => it !== this.systemApi.getMainAccount().email),
        };
        if (noCache) {
            const promises = _accountIds.map(accountId => this.mailConfApi.loadMailConf(accountId));
            await Promise.allSettled(promises);
        }
        try {
            const entryDt = await this.listMailEntryByAccountIds(dt, urlKey, noCache, _accountIds);
            const keys = Object.keys(entryDt);
            const confPromises = keys.map(accountId => this.buildFolderConf(accountId));
            await Promise.all(confPromises);
            const mailBoxModelsPromises = keys.map(accountId => this.modelHandler.handleCommonFolderRet(entryDt[accountId], [], accountId));
            const mailBoxModelsRes = await Promise.all(mailBoxModelsPromises);
            const result = {};
            mailBoxModelsRes.forEach((mailBoxModels, index) => {
                const accountId = keys[index];
                if (entries) {
                    if (entries[accountId] && !!entries[accountId].length) {
                        entries[accountId].push(...entryDt[accountId]);
                    }
                    else {
                        entries[accountId] = entryDt[accountId] || [];
                    }
                }
                result[accountId] = mailBoxModels;
            });
            return result;
        }
        catch (e) {
            return Promise.reject(this.commonCatch(e));
        }
    }
    async doStarContactUnread(_account) {
        const { starList, addressContactMap } = await this.mailApi.doListStarContact(_account);
        const startListWithNewUnread = await this.updateStarUnread(starList, addressContactMap);
        console.log('startListWithNewUnread', startListWithNewUnread);
        return startListWithNewUnread;
    }
    getDoStatMessagesParams(updateStat, fids, filter) {
        if (updateStat) {
            return {
                fids: Array.isArray(fids) ? fids : [mailBoxOfDefault.id],
            };
        }
        return {
            filter: filter || {
                defer: `:${moment().format('YYYYMMDD')}`,
            },
        };
    }
    async doStatMessages(noCache, updateStat, params, _account) {
        const urlKey = 'statMailCount';
        if (noCache) {
            await this.mailConfApi.loadMailConf(_account);
        }
        const mailBox = {
            childrenCount: 0,
            entry: {
                mailBoxName: mailBoxOfDefer.name || '',
                mailBoxCurrentUnread: 0,
                mailBoxUnread: 0,
                mailBoxTotal: 0,
                mailBoxType: 'sys',
                mailBoxId: mailBoxOfDefer.id,
                mailBoxParent: 0,
                threadMailBoxTotal: 0,
                threadMailBoxUnread: 0,
                threadMailBoxCurrentUnread: 0,
                deferCount: 0,
                id: mailBoxOfDefer.sort + '',
                sort: mailBoxOfDefer.sort,
                _deep: 1,
                messageSize: 0,
            },
            mailBoxId: mailBoxOfDefer.id,
            children: [],
        };
        try {
            const url = this.buildUrl(urlKey, undefined, undefined, _account);
            const req = this.getDoStatMessagesParams(updateStat, params === null || params === void 0 ? void 0 : params.fids, params === null || params === void 0 ? void 0 : params.filter);
            const apiRet = await this.impl.post(url, req, this.getConfigForHttp(urlKey, {
                url,
                data: req,
                method: 'post',
                cachePolicy: noCache ? 'refresh' : undefined,
                _account,
            }));
            const res = this.unpackFolderData(apiRet);
            if (res.code !== MailAbstractHandler.sOk || !res.var || !res.var.all) {
                console.error('[doStatMessages] error', res.code);
                return null;
            }
            mailBox.entry.deferCount = res.var.all.msgcnt || 0;
            mailBox.entry.mailBoxUnread = res.var.all.msgcnt || 0;
            mailBox.entry.mailBoxCurrentUnread = res.var.all.msgcnt || 0;
            mailBox.entry.threadMailBoxUnread = res.var.all.msgcnt || 0;
            mailBox.entry.threadMailBoxCurrentUnread = res.var.all.msgcnt || 0;
            mailBox.entry.messageSize = res.var.all.msgsize || 0;
            return mailBox;
        }
        catch (e) {
            console.error('[doStatMessages] error', e);
            return null;
        }
    }
    async doStatMessagesUnFollow(noCache, _account) {
        if (noCache) {
            await this.mailConfApi.loadMailConf(_account);
        }
        const mailBoxs = [
            {
                childrenCount: 0,
                entry: {
                    mailBoxName: mailBoxOfCustomerUnFollow.name || '',
                    mailBoxCurrentUnread: 0,
                    mailBoxUnread: 0,
                    mailBoxTotal: 0,
                    mailBoxType: 'sys',
                    mailBoxId: mailBoxOfCustomerUnFollow.id,
                    mailBoxParent: 0,
                    threadMailBoxTotal: 0,
                    threadMailBoxUnread: 0,
                    threadMailBoxCurrentUnread: 0,
                    deferCount: 0,
                    id: mailBoxOfCustomerUnFollow.id + '',
                    sort: mailBoxOfCustomerUnFollow.sort,
                    _deep: 1,
                },
                mailBoxId: mailBoxOfCustomerUnFollow.id,
                children: [],
            },
            {
                childrenCount: 0,
                entry: {
                    mailBoxName: mailBoxOfUnFollow.name || '',
                    mailBoxCurrentUnread: 0,
                    mailBoxUnread: 0,
                    mailBoxTotal: 0,
                    mailBoxType: 'sys',
                    mailBoxId: mailBoxOfUnFollow.id,
                    mailBoxParent: 0,
                    threadMailBoxTotal: 0,
                    threadMailBoxUnread: 0,
                    threadMailBoxCurrentUnread: 0,
                    deferCount: 0,
                    id: mailBoxOfUnFollow.id + '',
                    sort: mailBoxOfUnFollow.sort,
                    _deep: 1,
                },
                mailBoxId: mailBoxOfUnFollow.id,
                children: [],
            },
        ];
        try {
            const httpApi = api.getDataTransApi();
            const currentUser = this.systemApi.getCurrentUser();
            const node = this.storeApi.getCurrentNode();
            const res = await httpApi.get(this.systemApi.getUrl('getNumberOfCustomerUnFollow'), { multiple: false, sid: (currentUser === null || currentUser === void 0 ? void 0 : currentUser.sessionId) || '', node, subEmails: [_account] }, { contentType: 'json' });
            const { data, success } = res.data || {};
            if (success && data) {
                mailBoxs[0].entry.mailBoxTotal = data.customerCount || 0;
                mailBoxs[0].entry.threadMailBoxTotal = data.customerCount || 0;
                mailBoxs[1].entry.mailBoxTotal = data.nonCustomerCount || 0;
                mailBoxs[1].entry.threadMailBoxTotal = data.nonCustomerCount || 0;
            }
            return mailBoxs;
        }
        catch (e) {
            console.error('[doStatMessagesUnFollow] error', e);
            return null;
        }
    }
    async getDeliveryTagUnread(value, _account) {
        const urlKey = 'statMailCount';
        try {
            const url = this.buildUrl(urlKey, undefined, undefined, _account);
            const req = {
                filter: {
                    systemLabel: value,
                },
            };
            const apiRet = await this.impl.post(url, req, this.getConfigForHttp(urlKey, {
                url,
                data: req,
                method: 'post',
                cachePolicy: 'refresh',
                _account,
            }));
            const res = this.unpackFolderData(apiRet);
            if (res.code !== MailAbstractHandler.sOk || !res.var || !res.var.all) {
                console.error('[getDeliveryTagUnread] error', res.code);
                return null;
            }
            return res.var.all.newmsgcnt;
        }
        catch (e) {
            console.error('[getDeliveryTagUnread] error', e);
            return null;
        }
    }
    getAllFids(fids = [mailBoxOfDefault.id], _account) {
        var _a;
        const actions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        const { mailBoxDic } = actions || {};
        if (mailBoxDic) {
            Object.keys(mailBoxDic).forEach(it => {
                const element = actions.mailBoxDic && actions.mailBoxDic[parseInt(it, 10)];
                if (element && !element.locked && element.id !== String(mailBoxOfDefault.id) && +element.mailBoxId) {
                    fids.push(+element.mailBoxId);
                }
            });
        }
        return fids;
    }
    async listMailEntry(dt, urlKey, noCache, _account) {
        var _a;
        const url = this.buildUrl(urlKey, undefined, undefined, _account);
        const isCorpMailMode = this.systemApi.getIsCorpMailMode();
        if (isCorpMailMode) {
            if (!dt) {
                dt = {};
            }
            dt.threads = true;
            dt.stats = true;
        }
        const apiRet = await this.impl.post(url, dt, this.getConfigForHttp(urlKey, {
            url,
            data: dt,
            method: 'post',
            cachePolicy: noCache ? 'refresh' : undefined,
            _account,
        }));
        const res = this.unpackFolderData(apiRet);
        if (res.code !== MailAbstractHandler.sOk || !res.var) {
            throw new Error(String(res.code) || 'unknown_err');
        }
        const data = res.var;
        const actions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        actions.mailBoxOriginData = data;
        const entryDt = this.mappingToMailBoxEntry(data, _account);
        return entryDt;
    }
    async listMailEntryByAccountIds(dt, urlKey, noCache, _accountIds) {
        const _account = this.systemApi.getMainAccount().email;
        const url = this.buildUrl(urlKey, undefined, undefined, _account);
        const isCorpMailMode = this.systemApi.getIsCorpMailMode();
        if (isCorpMailMode) {
            if (!dt) {
                dt = {};
            }
            dt.threads = true;
            dt.stats = true;
        }
        const apiRet = await this.impl.post(url, dt, this.getConfigForHttp(urlKey, {
            url,
            data: dt,
            method: 'post',
            cachePolicy: noCache ? 'refresh' : undefined,
            _account,
        }));
        const res = this.unpackFolderData(apiRet);
        if (res.code !== MailAbstractHandler.sOk || !res.var) {
            throw new Error(String(res.code) || 'unknown_err');
        }
        const data = res.var;
        const map = new Map();
        data.forEach(item => {
            const key = (item === null || item === void 0 ? void 0 : item.belongEmail) || '';
            if (key) {
                const arr = map.get(key);
                if (arr) {
                    arr.push(item);
                }
                else {
                    map.set(key, [item]);
                }
            }
        });
        const result = {};
        map.forEach((value, key) => {
            const entryDt = this.mappingToMailBoxEntry(value, key);
            result[key] = entryDt;
        });
        return result;
    }
    getFolderErrorMsgByErroCode(errCode) {
        const errorInfo = this.getErrMsg(errCode, undefined, undefined, { errResult: FolderErrResult });
        return errorInfo.title;
    }
    getFolderErrorMsgByResponse(res) {
        var _a, _b, _c, _d;
        const resCode = ((_b = (_a = res) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || ((_d = (_c = res) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.code);
        if (resCode) {
            return this.getFolderErrorMsgByErroCode(resCode);
        }
        return '';
    }
    async createUserFolder(items, _account) {
        try {
            const urlKey = 'createUserFolder';
            const url = this.buildUrl(urlKey, undefined, undefined, _account);
            const isCorpMailMode = this.systemApi.getIsCorpMailMode();
            if (isCorpMailMode) {
                corpMailUtils.transformCorpCreateUserFolderParams(items);
            }
            const dt = { items };
            const apiRet = await this.impl.post(url, dt, this.getConfigForHttp(urlKey, {
                url,
                data: dt,
                method: 'post',
                noErrorMsgEmit: true,
                _account,
            }));
            const res = this.unpackFolderData(apiRet);
            if (res.code === MailAbstractHandler.sOk && res.var) {
                const data = res.var;
                return Promise.resolve(data);
            }
            const resCode = res.code;
            const errMsg = this.getFolderErrorMsgByErroCode(resCode);
            return Promise.reject(errMsg);
        }
        catch (ex) {
            const errorMsg = this.getFolderErrorMsgByResponse(ex);
            if (errorMsg) {
                return Promise.reject(errorMsg);
            }
            return Promise.reject(ex);
        }
    }
    async updateUserFolder(items, _account) {
        try {
            const urlKey = 'updateUserFolder';
            const url = this.buildUrl(urlKey, undefined, undefined, _account);
            const dt = { items };
            const apiRet = await this.impl.post(url, dt, this.getConfigForHttp(urlKey, {
                url,
                data: dt,
                method: 'post',
                noErrorMsgEmit: true,
                _account,
            }));
            const res = this.unpackFolderData(apiRet);
            if (res.code === MailAbstractHandler.sOk) {
                return Promise.resolve(true);
            }
            return Promise.reject({ code: res.code });
        }
        catch (ex) {
            const errorMsg = this.getFolderErrorMsgByResponse(ex);
            if (errorMsg) {
                return Promise.reject(errorMsg);
            }
            return Promise.reject(ex);
        }
    }
    async deleteUserFolder(ids, _account) {
        try {
            const urlKey = 'deleteUserFolder';
            const url = this.buildUrl(urlKey, undefined, undefined, _account);
            const dt = {
                ids,
            };
            const apiRet = await this.impl.post(url, dt, this.getConfigForHttp(urlKey, {
                url,
                data: dt,
                method: 'post',
                _account,
            }));
            const res = this.unpackFolderData(apiRet);
            if (res.code === MailAbstractHandler.sOk) {
                return Promise.resolve(true);
            }
            const resCode = res.code;
            const errMsg = this.getFolderErrorMsgByErroCode(resCode);
            return Promise.reject(errMsg);
        }
        catch (ex) {
            const errorMsg = this.getFolderErrorMsgByResponse(ex);
            if (errorMsg) {
                return Promise.reject(errorMsg);
            }
            return Promise.reject(ex);
        }
    }
    async buildFolderConf(_account) {
        var _a;
        const actions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        if (actions) {
            const isCorpMail = this.systemApi.getIsCorpMailMode();
            let value = null;
            if (!isCorpMail) {
                value = await this.mailConfApi.getFolderSettings(_account);
            }
            const ret = value ? JSON.parse(value) : { folder: [] };
            if (ret && ret.folder) {
                ret.folder.forEach(it => {
                    if (it && it.length === 2 && it[0] && it[1]) {
                        let mailBoxConf = actions.mailBoxConfs[it[0]];
                        if (!mailBoxConf) {
                            mailBoxConf = {
                                id: it[0],
                                fold: it[1],
                                sort: 1000,
                            };
                        }
                        else {
                            mailBoxConf.fold = it[1];
                        }
                        actions.mailBoxConfs[it[0]] = mailBoxConf;
                    }
                });
                actions.lastUserAttrUpdateTime = new Date().getTime();
            }
        }
    }
    handleFolderRet(data, gpCount, _account) {
        var _a;
        const ret = [];
        const trans = {};
        const mailCount = {};
        const threadMailCount = {};
        let total = 0;
        let threadTotal = 0;
        const actions = (_a = this.mailApi.getActions({
            actions: this.actions,
            subActions: this.subActions,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        if (gpCount) {
            const { fid } = gpCount;
            if (fid) {
                fid.forEach(it => {
                    if (it.val !== undefined) {
                        mailCount[Number(it.val)] = it.cnt;
                        threadMailCount[Number(it.val)] = it.threadCount || 0;
                        total += it.cnt;
                        threadTotal += it.cnt;
                    }
                });
            }
        }
        {
            const redMailBox = {
                childrenCount: 0,
                entry: {
                    mailBoxName: getIn18Text('QUANBU'),
                    mailBoxCurrentUnread: total,
                    mailBoxUnread: total,
                    threadMailBoxTotal: 0,
                    threadMailBoxUnread: threadTotal,
                    threadMailBoxCurrentUnread: threadTotal,
                    mailBoxTotal: 0,
                    mailBoxType: 'sys',
                    mailBoxId: mailBoxOfAllRes.id,
                    mailBoxParent: 0,
                    id: '0',
                    sort: actions.mailBoxConfs[mailBoxOfRdFlag.id].sort,
                    messageSize: 0,
                },
                children: [],
            };
            ret.push(redMailBox);
            trans[mailBoxOfAllRes.id] = redMailBox;
        }
        data.forEach(item => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            const { id } = item;
            const entry = {
                mailBoxName: item.name,
                mailBoxCurrentUnread: ((_a = item === null || item === void 0 ? void 0 : item.stats) === null || _a === void 0 ? void 0 : _a.unreadMessageCount) || 0,
                mailBoxUnread: ((_b = item === null || item === void 0 ? void 0 : item.stats) === null || _b === void 0 ? void 0 : _b.unreadMessageCount) || 0,
                mailBoxTotal: ((_c = item === null || item === void 0 ? void 0 : item.stats) === null || _c === void 0 ? void 0 : _c.messageCount) || 0,
                threadMailBoxTotal: Math.max(((_d = item === null || item === void 0 ? void 0 : item.stats) === null || _d === void 0 ? void 0 : _d.unreadThreadCount) || 0, 0),
                threadMailBoxUnread: Math.max(((_e = item === null || item === void 0 ? void 0 : item.stats) === null || _e === void 0 ? void 0 : _e.unreadThreadCount) || 0, 0),
                threadMailBoxCurrentUnread: Math.max(((_f = item === null || item === void 0 ? void 0 : item.stats) === null || _f === void 0 ? void 0 : _f.threadCount) || 0, 0),
                mailBoxType: item.flags.system ? 'sys' : 'customer',
                mailBoxId: id,
                mailBoxParent: item.parent,
                id: '' + (((_g = actions.mailBoxConfs[id]) === null || _g === void 0 ? void 0 : _g.sort) || id),
                pid: item.parent,
                locked: item.auth2Locked,
                keepPeriod: item.keepPeriod,
                sort: (_h = actions.mailBoxConfs[id]) === null || _h === void 0 ? void 0 : _h.sort,
                messageSize: ((_j = item === null || item === void 0 ? void 0 : item.stats) === null || _j === void 0 ? void 0 : _j.messageSize) || 0,
            };
            {
                const countElement = mailCount[id] || 0;
                const threadCountElement = threadMailCount[id] || 0;
                entry.mailBoxCurrentUnread = countElement;
                entry.mailBoxUnread = countElement;
                entry.threadMailBoxCurrentUnread = threadCountElement;
                entry.threadMailBoxUnread = threadCountElement;
            }
            trans[id] = {
                childrenCount: 0,
                entry,
                children: [],
            };
        });
        const children = {};
        data.forEach(item => {
            const { id } = item;
            const pid = item.parent;
            const model = trans[id];
            model.mailBoxId = id;
            const mailBoxConf = actions.mailBoxConfs[id];
            if (!(mailBoxConf === null || mailBoxConf === void 0 ? void 0 : mailBoxConf.hide)) {
                model.entry.mailBoxName = (mailBoxConf === null || mailBoxConf === void 0 ? void 0 : mailBoxConf.name) || model.entry.mailBoxName;
                if (model.entry.mailBoxType === 'sys') {
                    ret.push(model);
                }
                else if (model.entry.mailBoxType === 'customer') {
                    if (pid === 0) {
                        ret.push(model);
                    }
                    else {
                        let list = children[pid];
                        if (!list) {
                            list = [];
                        }
                        list.push(model);
                        children[pid] = list;
                    }
                }
            }
        });
        Object.keys(children).forEach(i => {
            if (Object.prototype.hasOwnProperty.apply(children, [i]) && children[Number(i)]) {
                children[Number(i)].forEach(it => {
                    const parent = trans[Number(i)];
                    if (parent) {
                        if (parent.children) {
                            parent.children.push(it);
                        }
                        else {
                            parent.children = [it];
                        }
                        parent.childrenCount += 1;
                        this.modelHandler.handleParentCount(trans, parent, it.entry.mailBoxUnread, it.entry.threadMailBoxUnread);
                    }
                });
            }
        });
        return ret;
    }
    travelAndGetAllNode(mailBoxModels, trans) {
        if (mailBoxModels && mailBoxModels.length > 0) {
            mailBoxModels.forEach(it => {
                if (it.mailBoxId) {
                    trans[+it.mailBoxId] = it;
                }
                if (it.children && it.children.length > 0) {
                    this.travelAndGetAllNode(it.children, trans);
                }
            });
        }
    }
    async unlockSecurityLock(password, _account) {
        try {
            const urlKey = 'unlockSecurityLock';
            const url = this.buildUrl(urlKey, undefined, undefined, _account);
            const apiRet = await this.impl.post(url, { password }, this.getConfigForHttp(urlKey, {
                url,
                data: { password },
                method: 'post',
                responseType: 'text',
                expectedResponseType: 'json',
                _account,
            }));
            return ((apiRet === null || apiRet === void 0 ? void 0 : apiRet.data) || apiRet);
        }
        catch (ex) {
            return { code: 'UNKNOWN_ERROR' };
        }
    }
}
MailFolderHandler.debugMailPopWindow = false;
